import { faCaretDown } from '@fortawesome/pro-solid-svg-icons'
import { Form, Icon, Select, Text } from '@/ui'
import { TypographyStyles } from '@/styles'
import { FormikStringSchema, useFieldHelpers } from '@/base'

const defaultOptions = [
  {
    value: 'self_pay',
    title: 'Self-pay',
    description: 'Private pay/cash',
  },
  {
    value: 'insurance_government',
    title: 'Insurance - Government',
    description: 'Medicare, Medicaid, CHIP, TRICARE/VA, etc.',
  },
  {
    value: 'insurance_commercial_in_network',
    title: 'Insurance - Commercial - In network',
    description: 'PPO, HMO, etc.',
  },
  {
    value: 'insurance_commercial_out_of_network',
    title: 'Insurance - Commercial - Out of network',
    description: 'PPO, HMO, etc.',
  },
  {
    value: 'employer_programs',
    title: 'Employer Programs',
    description: 'EAP, contracts (e.g. schools). etc.',
  },
  {
    value: 'platforms_networks',
    title: 'Platforms/Networks',
    description: 'BetterHelp, Alma, etc.',
  },
  {
    value: 'other',
    title: 'Other',
    description: 'Other',
  },
]

export const PayerTypeSelect = ({
  label,
  name,
  placeholder,
  schema,
}: {
  label?: string
  name: string
  placeholder?: string
  schema?: FormikStringSchema
}) => {
  const { field } = useFieldHelpers({ name })

  const currentSelection = defaultOptions.find(
    (option) => option.value === field.value
  )

  return (
    <Form.Select
      label={label}
      name={name}
      placeholder={placeholder}
      schema={schema}
    >
      <Select.Trigger>
        <Select.Value placeholder={placeholder} className="w-full h-8">
          {currentSelection ? (
            <>
              <Text
                variant={TypographyStyles.BODY_SM}
                className="overflow-auto"
              >
                {currentSelection.title}
              </Text>
              <Text
                variant={TypographyStyles.BODY_XS}
                className="overflow-auto"
              >
                {currentSelection.description}
              </Text>
            </>
          ) : (
            placeholder
          )}
        </Select.Value>
        <Select.Icon asChild>
          <Icon
            icon={faCaretDown}
            className="h-4 w-4"
            color="text-neutral-500"
          />
        </Select.Icon>
      </Select.Trigger>
      <Select.Content>
        {defaultOptions.map(({ value, title, description }) => (
          <Select.Item value={value} key={value}>
            <Text variant={TypographyStyles.BODY_SM}>{title}</Text>
            <Text variant={TypographyStyles.BODY_XS}>{description}</Text>
          </Select.Item>
        ))}
      </Select.Content>
    </Form.Select>
  )
}
